import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { LoadError, errMessage } from "@/components/LoadError";
import { Check } from "lucide-react";

const sectionLabel = "text-[11px] font-semibold uppercase tracking-wider text-zinc-400";
const leesVak = "rounded-md bg-zinc-50 border border-zinc-200 px-3 py-2 text-sm text-zinc-800 whitespace-pre-wrap break-words";

const Tekst = ({ waarde, testid }) => (
  waarde && String(waarde).trim()
    ? <div data-testid={testid} className={leesVak}>{waarde}</div>
    : <div data-testid={testid} className="text-sm text-zinc-400 italic">Niet ingevuld</div>
);

// v16 B2: één eerdere aanlevering, alleen lezen. Eigen state; raakt het formulier nooit.
export const AanleveringLezen = ({ week, locatie, kpis }) => {
  const [doc, setDoc] = useState(null);
  const [fout, setFout] = useState("");
  const laad = () => {
    setFout("");
    api.get(`/call-prep?week=${week}&locatie=${encodeURIComponent(locatie)}`)
      .then((r) => setDoc(r.data)).catch((e) => setFout(errMessage(e)));
  };
  useEffect(laad, [week, locatie]);

  if (fout) return <LoadError error={fout} onRetry={laad} testid={`eerder-lezen-error-${week}`} />;
  if (!doc) return <div data-testid={`eerder-lezen-laden-${week}`} className="text-sm text-zinc-400 py-3">Laden…</div>;
  return (
    <div data-testid={`eerder-lezen-${week}`} className="space-y-4 pt-3">
      <div className="space-y-2">
        <div className={sectionLabel}>De cijfers</div>
        {(kpis || []).map((k) => {
          const v = (doc.kpis || {})[k.id] || {};
          return (
            <div key={k.id} className="rounded-[10px] border border-zinc-200 p-3 bg-white space-y-1.5">
              <div className="font-heading text-sm font-bold text-zinc-800">{k.label}</div>
              <Tekst waarde={v.value} testid={`eerder-kpi-value-${week}-${k.id}`} />
              <div className="text-xs text-zinc-500 italic">{k.vraag}</div>
              <Tekst waarde={v.antwoord} testid={`eerder-kpi-antwoord-${week}-${k.id}`} />
            </div>
          );
        })}
      </div>
      <div className="space-y-2">
        <div className={sectionLabel}>Voorbereiding &amp; checks</div>
        {(doc.checks || []).length === 0 && <p className="text-sm text-zinc-400">Geen checks in deze week.</p>}
        {(doc.checks || []).map((p) => {
          const opm = (doc.opmerkingen || {})[p.id] || "";
          return (
            <div key={p.id} data-testid={`eerder-check-${week}-${p.id}`} className="rounded-[10px] border border-zinc-200 p-2.5 bg-white space-y-1.5">
              <div className="flex items-start gap-2 text-sm text-zinc-700">
                <span className={`mt-0.5 h-4 w-4 shrink-0 rounded-sm border flex items-center justify-center ${(doc.prep || {})[p.id] ? "bg-blue-600 border-blue-600" : "border-zinc-300"}`}>
                  {(doc.prep || {})[p.id] && <Check className="h-3 w-3 text-white" />}
                </span>
                <span><span className="text-zinc-400 font-mono text-xs mr-1.5">{p.id}</span>{p.text}{p.label && <span className="ml-2 text-[10px] font-semibold uppercase tracking-wider text-zinc-400">{p.label}</span>}</span>
              </div>
              <Tekst waarde={(doc.antwoorden || {})[p.id]} testid={`eerder-antwoord-${week}-${p.id}`} />
              {opm.trim() && <p data-testid={`eerder-opmerking-${week}-${p.id}`} className="text-xs text-zinc-500">Opmerking: {opm}</p>}
            </div>
          );
        })}
      </div>
      <div className="space-y-2">
        <div className={sectionLabel}>Wat wilde jij zelf inbrengen?</div>
        <Tekst waarde={doc.eigenPunt} testid={`eerder-eigen-punt-${week}`} />
      </div>
    </div>
  );
};
